var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.046,
    height: 47.265,
    viewBox: "0 0 56.046 47.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13346",
    "data-name": "Group 13346",
    transform: "translate(-938.986 -270.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(905.986 56.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 38.028,
    height: 29.247,
    rx: 1,
    transform: "translate(35 230)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M3,3,18.848,17.532,34.7,3",
    transform: "translate(35.166 228.452)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    transform: "translate(962.996 286.736) rotate(-45)",
    fill: "#fafafa",
    stroke: "#157fee",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.326,
    cy: 11.326,
    r: 11.326,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.326,
    cy: 11.326,
    r: 9.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6032",
    "data-name": "Path 6032",
    d: "M976.987,257.938l3.554-3.554v7.837",
    transform: "translate(-1.081 28.291)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.63ffc9a9da042ecc762b9f505db9db59.svg";
export { ForwardRef as ReactComponent };